import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RelatedLocationCard from '../related-location-card/related-location-card.component';
import SectionTitle from 'components/drawers/transaction-drawers/section-title/section-title.component';
import { StoreResult } from 'api/client-domain/client-domain.types';

type PrimaryLocationCardProps = {
  primaryLocation: Partial<StoreResult>;
  onNavigate: (id: string) => void;
};

const PrimaryLocationSection = ({
  primaryLocation,
  onNavigate,
}: PrimaryLocationCardProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <SectionTitle
        title={t('drawer.relatedLocationsDrawer.sectionTitles.primaryLocation')}
      />
      <Stack spacing={1}>
        <RelatedLocationCard
          relatedLocation={primaryLocation}
          onNavigate={onNavigate}
          data-testid="Primary.RelatedLocationCard"
        />
      </Stack>
    </Box>
  );
};

export default PrimaryLocationSection;
